import React from 'react';

interface ProductCardProps {
    title: string;
    subtitle: string;
    image: React.ComponentType<React.SVGProps<SVGSVGElement>>;
    onClick: () => void;
}

export function ProductCard({ title, subtitle, image: ImageComponent, onClick }: ProductCardProps) {
    return (
        <button
            onClick={onClick}
            className='group bg-neutral-white shadow-brand hover:border-primary-main flex h-24 w-full cursor-pointer items-center gap-2 rounded-md border border-transparent p-3 text-left transition-all hover:scale-105'
        >
            <div className='flex size-16 flex-shrink-0 items-center justify-center overflow-hidden rounded-md'>
                <ImageComponent className='size-full' />
            </div>
            <div className='flex-1'>
                <h4 className='text-primary-main mb-2'>{title}</h4>
                <p className='text-gray text-sm'>{subtitle}</p>
            </div>
        </button>
    );
}
